import React, { FC } from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Link, Box } from 'roo-ui/components';
import { FooterProps } from '../Footer';

const FooterLink = styled(Link)`
  display: block;
  font-size: ${themeGet('fontSizes.base')};
  padding-right: ${themeGet('space.4')};
  color: ${themeGet('colors.greys.steel')};
  text-decoration: underline;

  ${themeGet('mediaQueries.1')} {
    display: inline-block;
  }
`;

FooterLink.displayName = 'FooterLink';

export interface FooterLinksProps extends FooterProps {}

export const Links: FC<FooterLinksProps> = ({ links }) => (
  <Box data-print-style="hidden">
    {links.map((link, index) => (
      <FooterLink key={`footer-link-${index}`} {...link} />
    ))}
  </Box>
);
